import React from 'react';
import { productBadges, productVolume, priceInfo } from '../productMeta';

const renderStars = (rating) => {
    const full = Math.floor(rating);
    const empty = 5 - full;
    return (
        <>
            {[...Array(full)].map((_, i) => <i key={i} className="fas fa-star star"></i>)}
            {[...Array(empty)].map((_, i) => <i key={i + full} className="fas fa-star star-empty"></i>)}
        </>
    );
};

const ProductCard = ({ product, onOpen, addToCart, isFav = false, onToggleFav }) => {
    const badges = productBadges(product);
    const rating = product.rating || 5;
    const volume = productVolume(product);
    const pi = priceInfo(product);
    const hasDiscount = pi.discount_amount > 0;

    return (
        <div className="product-card group flex flex-col" onClick={onOpen}>
            <div className="relative">
                <img
                    src={product.photo || 'https://placehold.co/300x300/F5F0EB/6B7A6A?text=Product'}
                    alt={product.name}
                    className="w-full h-56 object-cover"
                    loading="lazy"
                />
                {(badges.length > 0 || hasDiscount) && (
                    <div className="absolute top-3 left-3 flex flex-wrap gap-1">
                        {hasDiscount && pi.badge && (
                            <span className="badge bg-red-500 text-white">{pi.badge}</span>
                        )}
                        {badges.slice(0, 2).map((badge, idx) => (
                            <span key={idx} className="badge">{badge}</span>
                        ))}
                    </div>
                )}
                <button
                    className={`absolute top-3 right-3 w-8 h-8 rounded-full backdrop-blur-sm flex items-center justify-center shadow-sm transition ${isFav ? 'bg-red-50 hover:bg-red-100' : 'bg-white/70 hover:bg-white'
                        }`}
                    onClick={(e) => { e.stopPropagation(); onToggleFav?.(product); }}
                    aria-label={isFav ? 'Убрать из избранного' : 'В избранное'}
                    title={isFav ? 'Убрать из избранного' : 'В избранное'}
                >
                    <i className={`${isFav ? 'fas text-red-500' : 'far text-[#1C1917]'} fa-heart text-sm`}></i>
                </button>
            </div>
            <div className="p-4 flex flex-col flex-1">
                <div className="flex justify-between items-center mb-1">
                    <div className="flex items-center gap-1 text-[#1C1917]">
                        {renderStars(rating)}
                    </div>
                    <div className="flex flex-col items-end">
                        {hasDiscount && (
                            <span className="text-xs text-gray-400 line-through">
                                {Math.round(pi.base_price)} ₽
                            </span>
                        )}
                        <span className={`text-sm font-semibold ${hasDiscount ? 'text-red-600' : 'text-[#1C1917]'}`}>
                            {Math.round(pi.final_price)} ₽
                        </span>
                    </div>
                </div>
                <h3 className="serif text-lg leading-tight mb-0.5">{product.name}</h3>
                <p className="text-sm text-gray-500">
                    {product.category}{volume ? ` · ${volume}` : ''}
                </p>
                <button
                    onClick={(e) => { e.stopPropagation(); addToCart(product); }}
                    className="mt-auto w-full py-2 border border-[#E8E3DD] rounded-full text-sm font-medium hover:bg-[#6B7A6A] hover:text-white hover:border-[#6B7A6A] transition"
                >
                    Добавить в корзину
                </button>
            </div>
        </div>
    );
};

export default ProductCard;